import isEmpty from "is-empty";
import {useState,useContext,createContext} from "react";



function PrivacyPolicy() {

  

  return (
    <div class="container">

       <main role="main" class="col-md-12 pt-3 px-4">
        
                <div class="about_sec2_content">

                    <h3>Privacy Policy</h3>
                    <p>
                    RightPe Software Service, having registered office at 
                    <b>106, Radhika Premier, Main Rd, Mahalaxmi Nagar, Indore, Madhya Pradesh 452010 </b>referred to as RightPe. RightPe, 
                    values Your trust &amp; respect Your privacy. 
                    This Privacy Policy provides You with details about the manner in which Your data is collected, 
                    stored &amp; used by us. You are advised to read this Privacy Policy carefully. By visiting RightPe's website  
                    applications,you expressly give us consent to use &amp; disclose your personal information in accordance with this Privacy Policy. 
                    If You do not agree to the terms of the policy, please do not use or access RightPe website or mobile applications.
                    </p>
                    <p>
                    Note: RightPe privacy policy may change at any time without prior notification. To make sure that you are aware of any changes, kindly review the policy periodically. 
                    This Privacy Policy shall apply uniformly to RightPe desktop website and RightPe mobile applications.
                    </p>

                    <h3>General</h3>


                    <p>RightPe will not sell, share or rent Your personal information to any 3rd party or use Your Name,email address,mobile number for unsolicited emails and/or SMS. Any emails and/or SMS sent by RightPe will only be in connection with the provision of agreed services &amp; products and this Privacy Policy. 
                    Periodically, RightPe may reveal general statistical information about RightPe and its users, such as number of visitors, number and type of goods and services purchased, etc. EPAY reserves the right to communicate Your personal information to any third party that makes a legallycompliant request for its disclosure
                    </p>

                    <h3>Personal Information</h3>


                    <p>Personal Information means and includes all information that can be linked to a specific individual or to identify any individual, such as name, address, telephone number, email ID, card number, cardholder name, 
                    card expiration date, information about your mobile phone, Data card, DTH service, electricity connection &amp; any details that may have been voluntarily provide by the user in connection with availing any of the services on RightPe Account. 
                    When You access through RightPe, RightPe may collect information regarding the domain and host from which You access the internet, the Internet Protocol [IP] address of the computer You are using, and anonymous site statistical data.
                    </p>

                    <h3>Use of Personal Information</h3>

                    <p>RightPe uses personal information to provide You with services &amp; products You explicitly requested for, 
                    to resolve disputes, troubleshoot concerns, help promote safe services, 
                    collect money, measure consumer interest in our services, inform You about offers, products, services, updates, customize Your experience, 
                    detect &amp; protect us against error, fraud and other criminal activity, enforce our terms and conditions, etc. RightPe also uses Your contact information to send You offers based on Your previous orders and interests.
                    </p>

                    <h3>Do we use Cookies?</h3>

                    <p>Yes. Cookies are small files that a site or its service provider transfers to your computer's hard drive through your Web browser 
                    (if you allow) that enables the site's or service provider's systems to recognize your browser and capture and remember certain information.
                    For instance, we use cookies to help us remember and process the items in your shopping cart. 
                    They are also used to help us understand your preferences based on previous or current site activity, which enables us to provide you with improved services. 
                    We also use cookies to help us compile aggregate data about site traffic and site interaction so that we can offer better site experiences and tools in the future.
                    </p>

                    <h3>We use cookies to:</h3>
                    <p>
                    *Help remember and process the transaction through the RightPe Account.
                    *Understand and save user's preferences for future visits.
                    *Compile aggregate data about site traffic and site interactions in order to offer better site experiences and tools in the future. 
                    We may also use trusted third party services that track this information on our behalf.
                    You can choose to have your computer warn you each time a cookie is being sent, or you can choose to turn off all cookies. 
                    You do this through your browser (like Internet Explorer) settings. 
                    Each browser is a little different, so look at your browser's Help menu to learn the correct way to modify your cookies.</p>

                    <p>
                    If users disable cookies in their browser: <br/>
                    If you disable cookies off, some features will be disabled It will turn off some of the features that make your site experience more<br/> 
                    efficient and some of our services will not function properly.</p>

                    <h3>Links to Other</h3>

                    <p>Occasionally, at our discretion, we may include or offer third party products or services on our website. 
                    These third-party sites have separate and independent privacy policies. 
                    RightPe therefore has no responsibility or liability for the content and activities of these linked sites. 
                    Nonetheless, we seek to protect the integrity of our site and welcome any feedback about these sites.</p>

                    <h3>Security</h3>

                    <p>RightPe has stringent security measures in place to protect the loss, misuse, and alteration of the information under our control. 
                    Whenever You change or access Your account information, RightPe offers the use of a secure server. 
                    Once Your information is in our possession RightPe adheres to strict security guidelines, protecting it against unauthorized access
                    Consent</p>

                    <p>RightPe never ask your OTP</p>
                    <p>RightPe never ask your credit card/Debit card number</p>

                    <p>By using RightPe and/or by providing Your information, You consent to the collection and use of the information 
                    You disclose on RightPe in accordance with this Privacy Policy, including but not limited to 
                    Your consent for sharing Your information as per this privacy policy.</p>

                </div>
      </main>
    </div>
  );
}

export default PrivacyPolicy;
